import React, { useEffect, useState } from 'react';
import { css } from 'styled-components';

//compoenents
import Layout from 'src/components/common/theme/Layout';
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { UitkHeading } from 'uitk-react-text';
import { UitkExpandoList, UitkExpandoListItem } from 'uitk-react-expando';

//helpers
import { useWindowDimensions } from 'src/components/common/useWindowDimentions';
import { checkValue } from 'src/components/functions';
import { getStore } from 'src/utils/store-utils';
import { getURLPath } from './helpers';

const ExpandoDescription = ({ menuItems }) => {
  const currentPath = getURLPath(window.location.href, 'end');

  return (
    <div className="expando-description-container">
      {menuItems?.map((item, index) => {
        const menuPath = getURLPath(item?.navigationItemUrl, 'end');
        return (
          <a
            className={`expando-menu-item ${currentPath === menuPath ? 'active' : ''} `}
            href={item?.navigationItemUrl}
            key={`expando-menu-icon-${index}`}
          >
            {item?.navigationItemText}{' '}
            <span>
              <UitkIcon name="navigate_next" className="expando-menu-item-icon" />
            </span>
          </a>
        );
      })}
    </div>
  );
};

const SubLevelMenuMobile = () => {
  const { width: windowWidth } = useWindowDimensions();

  const storeData = getStore();

  const {
    partnerHeaderSubNavigation,
    subHeaderHamburgerMenuBackgroundColor,
    subHeaderHamburgerMenuBackgroundHoverColor,
    subHeaderHamburgerMenuIconColor,
    subHeaderHamburgerMenuTextColor,
    subHeaderHamburgerMenuTextHoverColor,
    subHeaderHamburgerMenuBackgroundSelectedColor,
  } = storeData;

  const moduleCss = () => {
    const iconColor = checkValue(subHeaderHamburgerMenuIconColor) ? subHeaderHamburgerMenuIconColor : '#141d38';
    const menuBckColor = checkValue(subHeaderHamburgerMenuBackgroundColor)
      ? subHeaderHamburgerMenuBackgroundColor
      : '#ffffff';
    const menuTxtColor = checkValue(subHeaderHamburgerMenuTextColor) ? subHeaderHamburgerMenuTextColor : '#191e3b';
    const menuBckHoverColor = checkValue(subHeaderHamburgerMenuBackgroundHoverColor)
      ? subHeaderHamburgerMenuBackgroundHoverColor
      : '#191e3b';
    const menuTxtHoverColor = checkValue(subHeaderHamburgerMenuTextHoverColor)
      ? subHeaderHamburgerMenuTextHoverColor
      : '#ffffff';
    const menuBckSelectedColor = checkValue(subHeaderHamburgerMenuBackgroundSelectedColor)
      ? subHeaderHamburgerMenuBackgroundSelectedColor
      : checkValue(subHeaderHamburgerMenuBackgroundHoverColor)
      ? subHeaderHamburgerMenuBackgroundHoverColor
      : '#191e3b';

    return `
    &.partner-header-sub-level-menu-mobile {
      .sub-level-menu-mobile-trigger {
        color: ${iconColor} !important;
      }
      .sub-level-menu-mobile-item-container{
        background-color:${menuBckColor} !important;
      }
      .sub-level-menu-title,
      .expando-menu-item {
        color:${menuTxtColor} !important;
      }

      .uitk-expando-trigger-content .uitk-expando-trigger-icon {
        fill :${menuTxtColor} !important;
      }

      .expando-menu-item {
        &:hover {
          color:${menuTxtHoverColor} !important;
          background-color:${menuBckHoverColor} !important;
        }
        &.active {
          color:${menuTxtHoverColor} !important;
          background-color:${menuBckSelectedColor} !important;
        }
      }
    }
    `;
  };

  const [isOpenMenu, setIsOpenMenu] = useState(false);

  const [expandoData, setExpandoData] = useState([]);

  const domManipulationWhenClose = () => {
    setTimeout(() => {
      const scrollY = document.body.style.top;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      window.scrollTo(0, parseInt(scrollY || '0') * -1);
    }, 300);
  };

  const domManipulationWhenOpen = () => {
    document.body.style.top = `-${window.scrollY}px`;
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
  };

  //reset the menu on resize
  useEffect(() => {
    setIsOpenMenu(false);
    setExpandoData(
      expandoData.map((item) => ({
        ...item,
        isVisible: false,
      }))
    );
  }, [windowWidth]);

  //rest dropdowns when closing
  useEffect(() => {
    if (!isOpenMenu) {
      setExpandoData(
        expandoData.map((item) => ({
          ...item,
          isVisible: false,
        }))
      );
      domManipulationWhenClose();
    } else {
      domManipulationWhenOpen();
    }
  }, [isOpenMenu]);

  //set initial menu data
  useEffect(() => {
    if (checkValue(partnerHeaderSubNavigation, true)) {
      const data = partnerHeaderSubNavigation.map((obj) => ({
        expandoTitle: (
          <UitkHeading tag="h2" size={5} className="sub-level-menu-title">
            {obj?.Title}
          </UitkHeading>
        ),
        expandoDescription: <ExpandoDescription menuItems={obj?.navigationItems} />,
        isVisible: false,
        triggerPosition: 'trailing',
      }));
      setExpandoData(data);
    }
  }, []);

  return (
    <Layout
      HtmlTag="div"
      className="partner-header-sub-level-menu-mobile"
      css={css`
        ${moduleCss()}
      `}
    >
      <button className="sub-level-menu-mobile-trigger" onClick={() => setIsOpenMenu(!isOpenMenu)}>
        <UitkIcon name="menu" className="sub-level-menu-trigger-icon" size={UitkIconSize.MEDIUM} />
      </button>
      <div className={`sub-level-menu-mobile-item-container ${isOpenMenu ? 'open' : ''}`}>
        <div className="menu-item-container">
          <UitkExpandoList>
            {expandoData.map((listItem, index) => (
              <UitkExpandoListItem
                {...listItem}
                onToggle={() => {
                  listItem.isVisible = !listItem.isVisible;
                  setExpandoData([...expandoData]);
                }}
                key={`sub-level-menu-item-${index}`}
              />
            ))}
          </UitkExpandoList>
        </div>
      </div>
    </Layout>
  );
};

export default SubLevelMenuMobile;
